import React from 'react';
import { ConfiguratorsListing } from 'containers/configurators-listing';
import { useConfiguratorsListingPage } from './hooks';

export const ConfiguratorsListingPage = () => {
	useConfiguratorsListingPage();

	return <ConfiguratorsListing />;
};
